import { REQUEST_ID_HEADER, tagRequestID } from '../error/request-id'

// A failed image upload in the shape api-new hands on for any failed call
// ({ status, data }, axios's error.response), so serverMessage and
// <ErrorReference> read it the same way. Uppy's XHR upload bypasses axios,
// so its request id is read here from the XMLHttpRequest itself (storage's
// CORS exposes X-Request-ID). A network failure never reached the server:
// status 0, no body and no reference.
export const uploadFailure = xhr => {
  const status = xhr && typeof xhr.status === 'number' ? xhr.status : 0
  const response = { status, data: {}, headers: {} }
  if (!status) return response

  try {
    const body = JSON.parse(xhr.responseText || '')
    if (body && typeof body === 'object') response.data = body
  } catch (e) {
    // not JSON (a proxy's HTML page): no body to read, the status says enough
  }

  const id = typeof xhr.getResponseHeader === 'function' ? xhr.getResponseHeader(REQUEST_ID_HEADER) : null
  if (id) response.headers[REQUEST_ID_HEADER] = id
  tagRequestID({ response })
  return response
}
